import * as m from './Mensagens';

/*
 * Definição de tipos de erro
 *
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error
 * Obs: Devido ao transpiler (Babel), é necessário que a herança seja feita via prototype
 * para que o operador de checagem de tipo (instanceof) possa ser utilizado
 */

export function ApplicationError(message) {
  this.name = 'ApplicationError';
  this.message = message;
  this.stack = new Error().stack;
}
ApplicationError.prototype = Object.create(Error.prototype); // Herda o objeto Error (no JS um objeto herda o outro por prototipacao)
ApplicationError.prototype.constructor = ApplicationError;

export function MinimumVersionWarning(message) {
  this.name = 'MinimumVersionWarning';
  this.message = message;
  this.stack = new Error().stack;
}
MinimumVersionWarning.prototype = Object.create(ApplicationError.prototype);
MinimumVersionWarning.prototype.constructor = MinimumVersionWarning;

export function BusinessError(message) {
  this.name = 'BusinessError';
  this.message = message;
  this.stack = new Error().stack;
}
BusinessError.prototype = Object.create(ApplicationError.prototype);
BusinessError.prototype.constructor = BusinessError;

export function NetworkError(message) {
  this.name = 'NetworkError';
  this.message = message;
  this.stack = new Error().stack;
}
NetworkError.prototype = Object.create(ApplicationError.prototype);
NetworkError.prototype.constructor = NetworkError;

export function TimeoutError(message) {
  this.name = 'TimeoutError';
  this.message = message || m.ERRO_TIMEOUT;
  this.stack = new Error().stack;
}
TimeoutError.prototype = Object.create(NetworkError.prototype);
TimeoutError.prototype.constructor = TimeoutError;

export function DisconnectedError(message) {
  this.name = 'DisconnectedError';
  this.message = message || m.ERRO_APP_DESCONECTADO;
  this.stack = new Error().stack;
}
DisconnectedError.prototype = Object.create(NetworkError.prototype);
DisconnectedError.prototype.constructor = DisconnectedError;

export function InvalidTokenError(message) {
  this.name = 'InvalidTokenError';
  this.message = message || m.ERRO_APP_DESCONECTADO;
  this.stack = new Error().stack;
}
InvalidTokenError.prototype = Object.create(NetworkError.prototype);
InvalidTokenError.prototype.constructor = InvalidTokenError;
